import React, {useEffect, useState} from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';

function ScanFormsTable(props) {


    return (
        <Box display="flex" flexDirection="column" sx={{mt:"30px"}} className={props.isMobile ? "mobile-box" : "desktop-box"}>
            <Button color="primary" variant="contained" style={{marginTop:"10px", marginBottom:"10px", width:props.isMobile ? "100px" : "50%"}} onClick={()=>props.setRefresh(!props.refresh)}>Refresh</Button>
            {props.forms ?
                <TableContainer className={props.isMobile ? "mobile-table-box" : "desktop-table-box"} style={{height: "500px", overflowY:"scroll", width:props.isMobile? "100px":"50%"}}>
                <Table className={props.isMobile ? "mobile-table" : "desktop-table"}  sx={{zIndex:0}}>
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" style={{fontWeight: "bold"}}>Upload Date</TableCell>
                            <TableCell align="center" style={{fontWeight: "bold"}}>File Name</TableCell>
                            <TableCell align="center"></TableCell>
                            <TableCell align="center"></TableCell>
                        </TableRow>
                    </TableHead>
                    {props.forms.length > 0 ? 
                        <TableBody>
                            {props.forms.length > 0 ? props.forms.map((row, index)=> {
                                return(
                                    <TableRow key={index} tabIndex={-1}>
                                        <TableCell align="center">{row?.LastModified ? row.LastModified.replace("T", " | ").replace(".000Z", "") : null}</TableCell>
                                        <TableCell align="center">{row?.Key}</TableCell>
                                        <TableCell align="center"><Button onClick={()=>props.downloadData(row?.Key)} size="small" variant="contained" color="secondary">Download</Button></TableCell>
                                    </TableRow> 
                                )
                            }) : null}
                        </TableBody>
                    : <TableBody />}
                </Table>
                </TableContainer>
            : null}
        </Box>
    )
}

export default ScanFormsTable;